var _defineProperty = require("/builds/SocialGouv/legi-detect/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var legi = require("legi-codes-list");

var fuzz = require("fuzzball");

var sortByKey = require("./lib/sortByKey");

var codes = legi.map(function (code) {
  return {
    id: code.id,
    value: code.titrefull
  };
}); // the max code length is 18; we focus on 12 wich cover >=85% of cases and improve performance/precision

var maxCodeWordsCount = 12; // detect the most probable code for a given string with >=85% score required

var detectSingleCode = function detectSingleCode(source) {
  var matches = codes.filter(function (code) {
    return code.etat = "VIGUEUR";
  }).map(function (code) {
    return {
      code: code,
      source: source,
      score: fuzz.ratio(code.value, source)
    };
  }).sort(sortByKey("score")).filter(function (result) {
    return result.score >= Math.max(85, 100 - result.code.value.length);
  });
  return matches && matches[0];
}; // detect the most probable code for a given string (using ~maxCodeWordsCount words count)
// maximize precision by trying different words length


var detectCode = function detectCode(str) {
  var matches = Array.from({
    length: maxCodeWordsCount
  }, function (v, k) {
    return detectSingleCode(str.replace(/^(du )/i, "").split(/\n/)[0].split(" ").slice(0, k + 1).join(" "));
  }).filter(Boolean).sort(sortByKey("score"));
  var match = matches && matches[0];
  return match && _objectSpread({
    source: match.source
  }, match.code);
};

module.exports = {
  detectCode: detectCode,
  maxCodeWordsCount: maxCodeWordsCount
};